module.exports = __webpack_public_path__ + "static/media/email.d8f8f853.svg";